import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';

const PublicRouter = ({component: Component, children, ...rest}) => {
    const {token, isLoggedIn} = useSelector((store) => store.auth);
    const isAuthenticated = token && isLoggedIn;

    return (
        <Route
            {...rest}
            render={({location, ...props}) =>
                isAuthenticated ? (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {from: location}
                        }}
                    />
                ) : (
                    Component ? <Component location={location} {...props} /> : children
                )
            }
        />
    );
};

export default PublicRouter;